import React from 'react'
import PropTypes from 'prop-types'
import {Stack, Flex, Text, useMultiStyleConfig} from '@chakra-ui/react'
import {FormattedMessage, useIntl} from 'react-intl'
import {remCalc} from '../../../../theme/_utils'

const OrderReturnHeader = ({orderNumber, orderDate}) => {
    const styles = useMultiStyleConfig('Orders')
    const {formatDate} = useIntl()

    return (
        <Stack {...styles.orderReturnHeaderContainer}>
            <Flex {...styles.orderReturnHeaderTitleDescription}>
                <Text textStyle={['head-xlarge']} fontWeight={'medium'}>
                    <FormattedMessage
                        id="account_order_detail_return.label.select_items_to_return"
                        defaultMessage="Select the items to return"
                    />
                </Text>
                <Text textStyle={'body-medium'}>
                    <FormattedMessage
                        id="account_order_detail_return.label.return_description"
                        defaultMessage="description"
                        values={{
                            ul: (ulString) => (
                                <ul style={{paddingLeft: remCalc(24)}}>{ulString}</ul>
                            ),
                            li: (liString) => <li>{liString}</li>,
                        }}
                    />
                </Text>
            </Flex>

            <Flex {...styles.orderReturnHeaderNumDateContainer}>
                {orderNumber && (
                    <Text color="text.default">
                        <FormattedMessage
                            id="account_order_detail_return.label.order_number"
                            defaultMessage="<b>Order:</b> {orderNumber}"
                            values={{
                                orderNumber: orderNumber,
                                b: (boldString) => <b>{boldString}</b>,
                            }}
                        />
                    </Text>
                )}
                {orderDate && (
                    <Text color="text.default">
                        <FormattedMessage
                            id="account_order_detail_return.label.info.return_date"
                            defaultMessage="<b>Date:</b> {orderDate}"
                            values={{
                                orderDate: formatDate(new Date(orderDate), {
                                    year: 'numeric',
                                    month: '2-digit',
                                    day: '2-digit',
                                }),
                                b: (boldString) => <b>{boldString}</b>,
                            }}
                        />
                    </Text>
                )}
            </Flex>
        </Stack>
    )
}

OrderReturnHeader.propTypes = {
    orderNumber: PropTypes.string,
    orderDate: PropTypes.string,
}

export default OrderReturnHeader
